import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'left-side',
  templateUrl: './left-side.component.html',
  styleUrls: ['./left-side.component.css']
})
export class LeftSideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
